
import React from "react";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";

interface FormFooterProps {
  isLogin: boolean;
  loading: boolean;
  toggleFormMode: () => void;
}

const FormFooter = ({ isLogin, loading, toggleFormMode }: FormFooterProps) => {
  return (
    <>
      {/* Security message */}
      <div className="flex items-center gap-2 text-xs text-gray-500 mt-2">
        <ShieldCheck className="w-3 h-3" />
        <p>Vorm on kaitstud spämmi tuvastamise tehnoloogiaga.</p>
      </div>
      
      {/* Submit Button */}
      <Button 
        type="submit" 
        className="w-full mt-6 bg-kaija-accent hover:bg-opacity-90 text-white"
        disabled={loading}
      >
        {loading
          ? "Laadin..."
          : isLogin
          ? "Logi sisse"
          : "Loo konto"}
      </Button>
      
      {/* Toggle between login and signup */}
      <div className="mt-4 text-center text-sm">
        {isLogin ? (
          <p>
            Pole veel kontot?{" "}
            <button
              type="button"
              onClick={toggleFormMode}
              className="text-blue-600 hover:underline font-medium"
            >
              Registreeru
            </button>
          </p>
        ) : (
          <p>
            Sul on juba konto?{" "}
            <button
              type="button"
              onClick={toggleFormMode}
              className="text-blue-600 hover:underline font-medium"
            >
              Logi sisse
            </button>
          </p>
        )}
      </div>
    </>
  );
};

export default FormFooter;
